import RemoteMarkdown from './RemoteMarkdown'
import RemoteJsonText from './RemoteJsonText'
import text from './text'

export {
    RemoteMarkdown,
    RemoteJsonText,
    text,
}
